import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserService } from '../shared/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mailing-list',
  templateUrl: './mailing-list.component.html',
  styleUrls: ['./mailing-list.component.scss']
})
export class MailingListComponent implements OnInit {
  form: UntypedFormGroup
  formValues: any
  submitting = false
  hasError = false
  private subs = new Subscription()
  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.createFormValues()
    this.createForm()
  }

  createFormValues() {
    this.formValues = {
      first_name: ['', Validators.compose([Validators.required])],
      last_name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required])]
    }
  }

  createForm() {
    this.form = this.fb.group(this.formValues)
  }

  // convenience getter for form controls
  get f() {
    if (this.form && this.form.controls) {
      return this.form.controls
    }
  }

  submitForm() {
    this.submitting = true
    if (!this.form.valid) {
      this.submitting = false
      return
    }
    const params = this.cleanFormInput(this.form.value)
    this.subs.add(
      this.userService.subscribeToMailingList(params).subscribe(data => {
        if (data) {
          Swal.fire({
            title: 'Thank You for Subscribing!',
            icon: 'success',
            timer: 3000,
            showConfirmButton: false
          }).then(() => {
            this.submitting = false
          })
        }
      }, error => {
        if (error) {
          if (error.status === 409) {
            Swal.fire({
              title: 'Thank You!',
              text: 'You Are Already Subscribed',
              icon: 'success',
              timer: 3000,
              showConfirmButton: false
            }).then(() => {
              this.submitting = false
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: error.msg ? error.msg : 'Something Went Wrong',
              icon: 'error',
              timer: 2000,
              showConfirmButton: false
            }).then(() => {
              this.hasError = true
              this.submitting = false
            })
          }
        }
      })
    )
  }

  cleanFormInput(form: any) {
    // TODO: Implement Some Way To Clean Before Sending To Service
    return form
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

}

